import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFromPharmacy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "#FEF6EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 16,
			height: 16,
			rx: 8,
			fill: "white",
			stroke: "#B47F23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1639 8.71365C13.1596 7.89181 14.6533 8.01562 15.5001 8.99018C16.3469 9.96474 16.2261 11.421 15.2304 12.2428L13.4056 13.749L10.3391 10.2198L12.1639 8.71365Z",
			fill: "#B47F23"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.63713 14.6538C9.30261 15.4196 10.4767 15.5174 11.2593 14.8718L13.2122 13.2599L10.8019 10.4859L8.84899 12.0979C8.06685 12.7438 7.97201 13.8879 8.63713 14.6538Z",
			fill: "white",
			stroke: "#B47F23"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledFromPharmacy);
const Memo = memo(ForwardRef);
export default Memo;
